// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height' | 'color'>
const SvgFiletypePpt = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 158 206"
    {...props}
  >
    <path
      fill="#999"
      d="M0 4a4 4 0 0 1 4-4h95.807c2.366 0 4.637.932 6.322 2.595l33.193 32.762A9 9 0 0 1 142 41.762V183a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
    />
    <path
      fill="#fff"
      d="M4 6a2 2 0 0 1 2-2h92a2 2 0 0 1 2 2v26.5c0 5.523 4.477 10 10 10h26a2 2 0 0 1 2 2V181a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
    />
    <path
      fill="#999"
      d="M69.086 92.604V57.46c0-1.146-.963-2.063-2.101-1.935a35.5 35.5 0 0 0-21.78 10.84 35.49 35.49 0 0 0-7.048 38.003 35.47 35.47 0 0 0 19.207 19.204 35.5 35.5 0 0 0 13.582 2.698 35.48 35.48 0 0 0 35.26-31.524c.127-1.137-.788-2.098-1.933-2.1z"
    />
    <path
      fill="#999"
      d="M76.477 55.525c-1.138-.131-2.1.787-2.1 1.931v29.895h29.896c1.145 0 2.062-.961 1.932-2.098-.894-7.768-4.481-13.797-10.206-19.522-5.726-5.725-11.754-9.313-19.522-10.206M22 166a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v36a4 4 0 0 1-4 4H26a4 4 0 0 1-4-4z"
    />
    <path
      fill="#fff"
      d="M116.988 177.073v13.913c0 1.508.053 2.566.212 3.703h-4.867c.158-1.137.211-2.169.211-3.703v-13.913h-3.359c-1.587 0-2.724.053-3.782.185V173c1.058.132 2.222.185 3.756.185h11.003c1.852 0 2.91-.053 3.994-.185v4.258c-1.084-.132-2.09-.185-3.994-.185zM90.74 194.689h-4.76c.158-1.084.211-2.142.211-3.65v-14.31c0-1.349-.053-2.354-.212-3.623 1.19.053 2.064.079 3.624.079h5.634c2.672 0 4.629.661 5.951 1.984 1.111 1.111 1.72 2.777 1.72 4.761 0 2.116-.635 3.862-1.878 5.105-1.35 1.375-3.307 2.036-5.872 2.036h-4.63v3.915c0 1.508.054 2.645.212 3.703m-.211-11.347h4.523c2.142 0 3.359-1.19 3.359-3.28 0-.952-.264-1.746-.793-2.275-.556-.608-1.376-.872-2.566-.872h-4.523zM69.942 194.689h-4.76c.158-1.084.21-2.142.21-3.65v-14.31c0-1.349-.052-2.354-.21-3.623a71 71 0 0 0 3.623.079h5.634c2.671 0 4.629.661 5.951 1.984 1.11 1.111 1.72 2.777 1.72 4.761 0 2.116-.636 3.862-1.879 5.105-1.349 1.375-3.306 2.036-5.872 2.036h-4.628v3.915c0 1.508.053 2.645.211 3.703m-.211-11.347h4.523c2.142 0 3.359-1.19 3.359-3.28 0-.952-.265-1.746-.794-2.275-.555-.608-1.375-.872-2.565-.872H69.73zM56 190.113h4.576v4.576H56z"
    />
  </svg>
)
export default SvgFiletypePpt
